export const thirtyDays = 30 * 24 * 60 * 60 * 1000;
